$(function () {
	// 検討中リストから削除
	$("section.list .review-delete").click(function () {
		removeFromConsiderList($(this));
		$(this).closest('section.list').fadeOut(300, function () {
			// チェックをOFF
			$(this).find("label.checked").trigger("click");
			// すべて選択ボタンを更新
			$(".allcheck div")
				.removeClass("review_allcheck")
				.removeClass("review_allcheck_on")
				.addClass("review_allcheck" + ($("section.list:visible input[type='checkbox']:not(:checked)").length === 0 ? "_on" : ""))
				;
			if ($('section.list:visible').length == 0) {
				$('.allcheck').remove();
				$('.pagenum').first().before('<div class="no-review">検討中リストに物件が保存されていません。</div> ');
			}
			if($('.review_num').text() < 1) {
				$('.review_num').empty();
			}
		});
		return false;
	});

	// すべて選択
	$(document).on("click", "div.review_allcheck", function (event) {
		$("section.list:visible input[type='checkbox']:not(:checked)").each(function () {
			$(this).prop('checked', true);
		}).change(); // チェック状態を変更したのでchangeイベントを呼ぶ

		$(this).addClass('review_allcheck_on').removeClass('review_allcheck');
	});

	// すべて選択をはずす
	$(document).on("click", "div.review_allcheck_on", function (event) {
		$("section.list:visible input[type='checkbox']:checked").each(function () {
			$(this).prop('checked', false);
		}).change(); // チェック状態を変更したのでchangeイベントを呼ぶ

		$(this).addClass('review_allcheck').removeClass('review_allcheck_on');
	});

	// チェックボックスがクリックされた時に
	// 全てのチェックボックスがチェックされていたら、すべて選択の画像をチェックありにする
	// チェックされていないチェックボックスがあれば、すべて選択の画像をチェックなしにする
	$(document).on("click", "section.list label", function (event) {
		if ($("section.list:visible input[type='checkbox']:not(:checked)").length == 0) {
			$("div.review_allcheck").addClass('review_allcheck_on').removeClass('review_allcheck');
		} else {
			$("div.review_allcheck_on").addClass('review_allcheck').removeClass('review_allcheck_on');
		}
	});

	// 選択した住戸をまとめてお問い合わせ
	$('div.allcheck .btn').click(function () {
		if ($("section.list:visible input[type='checkbox']:checked").length == 0) {
			alert('お問い合わせをする物件を選択してください');
			return false;
		}
		var category_val = $('input[name="category"]').val();
		if (category_val == '1') {
			$(this).closest('#page-review').find('form.form-inq-roombuy').eq(0).submit();
		} else if (category_val == '2') {
			$(this).closest('#page-review').find('form.form-inq-roomrent').eq(0).submit();
		}
		return false;
	});

	// 検討中リストのモーダルウィンドウ
	$("#msgBox").modal({ closeButton: "#msgBox .msgClose" });

	// 検討中リストチェックボックス挙動 フッターナビゲーションの表示切替、親要素のクラス切替
	$("#page-review .list .check-btn input[type=checkbox]").toggleFooterNav("#footerFixed").trigger("change").fixedSubMenu(".fixed-submenu-sp");

	// 物件画像の外観・内観スライド
	$("#page-review .rslides").responsiveSlides();

	// 物件画像 遅延読込
	$("img.lazy").lazyload({
		effect: 'fadeIn',
		effectspeed: 500,
		threshold: 300,
	});
});
